export default "__VITE_ASSET__BSmMe2St__"